export default __webpack_public_path__ + "static/201-finger-pro-029de891db0bea15709347f52db1eac2.png";